import React, { useEffect, useState } from "react";
import { TimeoutWarningModal } from "./TimeoutWarningModal"
import { addEventListeners, removeEventListeners } from "../../utilitties/eventListener.util";
import { ERROR_REFRESH_TOKEN, FAILED_REFRESH_TOKEN, SESSION_CONFIG, SUCCESS_LOGOUT, SUCCESS_REFRESH_TOKEN } from "../../utilitties/constants";
import { apiLogout } from "../../services/logout.service";
import { STORAGE_LOCAL } from "../../models/storages";

export const TimeoutLogic = () => {
  const [isWarningModalOpen, setWarningModalOpen] = useState(false);
  const [isRedirected, setIsRedirected] = useState("false");

  useEffect(() => {
    const createTimeout1 = () => setTimeout(() => {
      setWarningModalOpen(true);
    }, SESSION_CONFIG.TIME_INACTIVE_IN_MS)

    const createTimeout2 = () => setTimeout(async () => {
      const { data, status } = await apiLogout()
      setIsRedirected("true")
      if (status === 200) {
        window.localStorage.removeItem(STORAGE_LOCAL.TOKEN)
        window.location.replace(data.nologin);
      }

    }, SESSION_CONFIG.SESSION_TIMEOUT_IN_MS)

    const listener = () => {
      if (!isWarningModalOpen) {
        clearTimeout(timeout)
        timeout = createTimeout1();
      }
    }

    // Initialization
    let timeout = isWarningModalOpen ? createTimeout2() : createTimeout1()
    addEventListeners(listener);

    // Cleanup
    return () => {
      removeEventListeners(listener);
      clearTimeout(timeout);
    }
  }, [isWarningModalOpen])


  const refreshToken = async () => {

    const result = await apiRefreshToken();
    if (result.message === SUCCESS_REFRESH_TOKEN) {
      window.localStorage.setItem(STORAGE_LOCAL.TOKEN, result.data.token)
      setWarningModalOpen(false);
    } else {
      console.log('Error al intentar actualizar token', result.error)
      const { data, status } = await apiLogout()
      setIsRedirected("true")
      setWarningModalOpen(false);
      if (status === 200) {
        window.location.replace(data.nologin);
      }
    }
  }
  
  useEffect(() => {
    window.sessionStorage.setItem(STORAGE_LOCAL.IS_REDIRECTED, isRedirected);
  }, [isRedirected]);

  const apiRefreshToken = async () => {
    try {
      const url = `api/Login/RefreshToken`;
      const response = await fetch(url)
      if (response.status === 200) {
        let result = await response.json();
        return { data: result, message: SUCCESS_REFRESH_TOKEN };
      } else {
        return { data: [], message: FAILED_REFRESH_TOKEN };
      }
    } catch (error) {
      return { data: [], message: ERROR_REFRESH_TOKEN, error: error };
    }
  }
  return (
    <div>
      {isWarningModalOpen && (
        <TimeoutWarningModal
          isOpen={isWarningModalOpen}
          onRequestClose={refreshToken}
        />
      )
      }
    </div>
  )
}